import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeEvery } from 'redux-saga/effects';

import { STUDENT_DATA_SAGA, STUDENT_DATA_SINGLE_SAGA } from 'reduxToolkit/actions';
import { commonSlice, studentDataSlice, studentDataSingleSlice } from 'reduxToolkit/reducers';
import { studentReducerTypes, studentSingleReducerTypes } from 'types';
import { apiCall, apiRoutes, getApiErrorMessage } from 'utils/helpers';

const { studentDataFailed, studentDataSuccess, studentDataStart } = studentDataSlice.actions;
const { studentDataSingleFailed, studentDataSingleSuccess, studentDataSingleStart } = studentDataSingleSlice.actions;
const { exceptionHandlerRequest } = commonSlice.actions;

const studentDataSaga = function* (payloadData: PayloadAction<studentReducerTypes.IStudentDataForm>): any {
    yield put(studentDataStart(payloadData.payload));
    try {
        const { page, search_word } = payloadData.payload;
        const params = {
            page,
            search_word,
        };
        const url = { ...apiRoutes.getStudents, params };

        const response = yield apiCall(url);
        if (response.status === 200) {
            yield put(studentDataSuccess(response.data.data));
        } else {
            const errorData = {
                status: false,
                error: getApiErrorMessage(response),
            };
            yield put(studentDataFailed(errorData));
        }
    } catch (error) {
        yield put(exceptionHandlerRequest(error));
    }
};

const studentDataSingleSaga = function* (
    payloadData: PayloadAction<studentSingleReducerTypes.IStudentDataSingleForm>
): any {
    yield put(studentDataSingleStart(payloadData.payload));
    try {
        const url = { ...apiRoutes.showSingleStudent };
        url.apiPath = url.apiPath.replace(
            ':studentId',
            payloadData.payload.studentId ? payloadData.payload.studentId.toString() : ''
        );

        const response = yield apiCall(url);
        if (response.status === 200) {
            yield put(studentDataSingleSuccess(response.data));
        } else {
            const errorData = {
                status: false,
                error: getApiErrorMessage(response),
            };
            yield put(studentDataSingleFailed(errorData));
        }
    } catch (error) {
        yield put(exceptionHandlerRequest(error));
    }
};

export const takeStudentDataRequest = function* () {
    yield takeEvery(STUDENT_DATA_SAGA, studentDataSaga);
};

export const takeStudentDataSingleRequest = function* () {
    yield takeEvery(STUDENT_DATA_SINGLE_SAGA, studentDataSingleSaga);
};
